import type { z } from 'zod';
import { supabase } from '@/lib/supabase';
import { ApiError, toApiError } from './errors';

/**
 * Calls a SQL function through PostgREST and validates the answer with Zod, so a
 * changed server contract fails loudly instead of rendering garbage.
 */
export async function rpc<S extends z.ZodType>(fn: string, args: Record<string, unknown>, schema: S): Promise<z.output<S>> {
  let response;
  try {
    response = await supabase.rpc(fn, args);
  } catch (error) {
    throw toApiError(error);
  }
  if (response.error) throw toApiError(response.error);
  const parsed = schema.safeParse(response.data);
  if (!parsed.success) {
    console.error(`[rpc] ${fn}: unexpected response`, parsed.error.issues);
    throw new ApiError('unknown', 'Сервер вернул неожиданный ответ.');
  }
  return parsed.data;
}

export async function rpcVoid(fn: string, args: Record<string, unknown>): Promise<void> {
  let response;
  try {
    response = await supabase.rpc(fn, args);
  } catch (error) {
    throw toApiError(error);
  }
  if (response.error) throw toApiError(response.error);
}
